export const FETCH_LOGIN_INFO = 'FETCH_LOGIN_INFO';
export const GENERATOR_BFSIMG = 'GENERATOR_BFSIMG';
export const GET_RECOMMEND_LIST = 'GET_RECOMMEND_LIST';
export const GET_MOVIE_STATUS = 'GET_MOVIE_STATUS';
export const FOLLOW_MOVIE_PATCH = 'FOLLOW_MOVIE_PATCH';
// import axios from '../../public/request.js'
// import BiliAjax from '@bilibili/bili-app-ajax'
// const http = new BiliAjax({
//   useCookie: true,
// })
// @ts-ignore
import Bjax from '@bilibili/bjax';
const bjax = new Bjax();
import axios from '../utils';
import cookie from '../../public/cookies.js';
import { getLoginInfo } from '../../public';
import * as mutations from './mutations';
import Vue from 'vue';
export default {
    [FETCH_LOGIN_INFO]({ commit, dispatch }) {
        getLoginInfo()
            .then(resp => {
            if (resp && resp.isLogin) {
                commit(mutations.SET_USER_INFO, resp);
                axios({
                    url: '/pgc/activity/year/report/2020/bangumi',
                    transData: false,
                    data: {
                        ts: new Date().getTime(),
                        csrf: cookie.get('bili_jct'),
                    },
                }).then((info) => {
                    commit(mutations.SET_INFO, info);
                    if (info.page1 && Object.keys(info.page1).length && info.page1.year_comic_time === 0) {
                        dispatch('GET_RECOMMEND_LIST');
                    }
                    if (info.page4 && Object.keys(info.page4).length && (info.page4.ep_view_num <= 1 || !info.page4.ep_view_num || !info.page4.season_title)) {
                        dispatch('GET_RECOMMEND_LIST');
                    }
                    if (!info.page4 || Object.keys(info.page4).length === 0) {
                        dispatch('GET_RECOMMEND_LIST');
                    }
                    if (Object.keys(info).length === 0) {
                        dispatch('GET_RECOMMEND_LIST');
                    }
                });
            }
        })
            .catch(() => {
            Vue.prototype.$toast.info('系统错误，请稍后再试~~');
        });
    },
    [GENERATOR_BFSIMG]({ commit }, { img, type }) {
        // return axios({
        //   url: '//www.bilibili.com/activity/upimage',
        //   data: {
        //     img: img,
        //   },
        //   method: 'post',
        // })
        return bjax
            .upload('//api.bilibili.com/x/upload/web/image', img)
            .then(resp => {
            console.log('resp==>', resp.data);
            const { location = '' } = resp.data || {};
            if (location) {
                commit(mutations.SET_SHAREIMG, {
                    url: location.replace(/^http(s)?:/, 'https:'),
                    type,
                });
            }
            else {
                Vue.prototype.$toast.info('生成图片失败，请截图保存');
            }
        })
            .catch(e => {
            Vue.prototype.$toast.info(e.message || '网络错误');
            return Promise.resolve('');
        });
    },
    [GET_RECOMMEND_LIST]({ commit, dispatch }) {
        return axios({
            url: '//api.bilibili.com/pgc/operation/api/static/season',
            data: {
                ts: new Date().getTime(),
                // wid: 10237,
                wid: 10742,
            },
        }).then(resp => {
            const list = resp || [];
            commit(mutations.SET_RECOMMEND_LIST, list);
            dispatch(GET_MOVIE_STATUS);
        });
    },
    [GET_MOVIE_STATUS]({ state, commit }) {
        const seasonIds = state.movieList
            .filter(i => i.indexValue)
            .map(i => i.indexValue)
            .join(',');
        axios({
            url: '//api.bilibili.com/pgc/web/follow/status',
            trans: false,
            data: {
                season_ids: seasonIds,
            },
        }).then(resp => {
            if (resp.code === 0) {
                const statusList = resp.result || {};
                // console.log('statusList==>', statusList)
                const finalList = state.movieList.map(i => {
                    const ssid = i.indexValue;
                    if (ssid && statusList[ssid] && statusList[ssid].isFollow === 1) {
                        return {
                            ...i,
                            followed: true,
                        };
                    }
                    else {
                        return {
                            ...i,
                            followed: false,
                        };
                    }
                });
                commit(mutations.SET_FINAL_LIST, finalList);
            }
        });
    },
    [FOLLOW_MOVIE_PATCH]({ state }, { idList }) {
        axios({
            url: '//api.bilibili.com/pgc/web/follow/batch/add',
            method: 'post',
            trans: false,
            data: {
                csrf: cookie.get('bili_jct'),
                season_ids: idList.join(','),
            },
        }).then(resp => {
            // console.log('resp==>', resp)
            if (resp.code === 0) {
                state.finalList.map(ins => {
                    if (idList.indexOf(ins.indexValue) > -1) {
                        ins.followed = true;
                    }
                });
            }
        });
    },
};
